/* AEVORA — fiche produit : bloc à onglets « Dans la boîte / Caractéristiques ».
   Les valeurs viennent des descriptions produit reelles (verifiees le 11/09/2026).
   Table par handle plutot que metafields : la section aevora-landing n'expose
   aucun metafield au front, et on ne veut afficher aucun chiffre non verifie.
   Un produit absent de la table n'affiche pas le bloc. */
(function () {
  var d = document;

  var ICON = {
    pieces: '<path d="M4 6h7v5H4zM13 6h7v5h-7zM4 13h7v5H4zM13 13h7v5h-7z"/>',
    led: '<path d="M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.3.3.5.7.5 1.1h6c0-.4.2-.8.5-1.1A6 6 0 0 0 12 3z"/>',
    glue: '<path d="M10 3h4v3h-4zM9 6h6l1 4v10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V10z"/>',
    tools: '<path d="M3 20l7-7M14 4l6 6-3 1-4-4zM10 13l4 4"/>',
    manual: '<path d="M4 5a2 2 0 0 1 2-2h12v18H6a2 2 0 0 1-2-2zM8 7h7M8 11h7"/>',
    cover: '<path d="M4 9l8-5 8 5v10H4zM4 9h16"/>',
    battery: '<path d="M3 8h14v8H3zM17 11h3v2h-3zM7 10v4M11 10v4"/>',
    level: '<path d="M4 20V10M10 20V4M16 20v-8M4 20h16"/>',
    clock: '<path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 7v5l3 2"/>',
    age: '<path d="M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM3 20a6 6 0 0 1 12 0M17 12a2.5 2.5 0 1 0 0-5M17 20a5 5 0 0 0-1.5-3.6"/>',
    size: '<path d="M3 8h18v8H3zM7 8v3M11 8v5M15 8v3M19 8v5"/>'
  };

  var DATA = {
    'le-pavillon-du-lotus': {
      box: [
        ['pieces', 'Pièces pré-découpées', 'Plus de 320, numérotées'],
        ['led', 'Éclairage LED', 'Circuit intégré à la maquette'],
        ['glue', 'Colle incluse', 'La quantité pour tout le montage'],
        ['manual', 'Notice en français', 'Pas à pas, illustrée'],
        ['cover', 'Capot anti-poussière', 'Fourni, pour l’exposition'],
        ['battery', 'Piles AAA', 'Non incluses — 3 nécessaires']
      ],
      specs: [
        ['level', 'Intermédiaire', 'Niveau'],
        ['pieces', '320+', 'Pièces'],
        ['clock', '18-28 h', 'Montage'],
        ['age', '14+', 'Âge'],
        ['size', '27 × 30 × 23 cm', 'Dimensions montées']
      ]
    },
    'l-antre-de-la-sorciere': {
      box: [
        ['pieces', 'Pièces pré-découpées', 'Environ 320, numérotées'],
        ['led', 'LED ambre et violet', 'Sur interrupteur'],
        ['glue', 'Colle incluse', 'La quantité pour tout le montage'],
        ['tools', 'Outils de montage', 'Fournis dans la boîte'],
        ['manual', 'Notice en français', 'Pas à pas, illustrée'],
        ['battery', 'Piles AAA', 'Non incluses']
      ],
      specs: [
        ['level', 'Intermédiaire', 'Niveau'],
        ['pieces', '320 environ', 'Pièces'],
        ['clock', '10-14 h', 'Montage'],
        ['age', '14+', 'Âge'],
        ['size', '27 × 25 × 20 cm', 'Dimensions montées']
      ]
    }
  };

  var CSS = [
    '.av-tabs{margin:18px 0 4px}',
    '.av-tabs-nav{display:flex;background:#F3E7E0;border-radius:999px;padding:5px;gap:4px}',
    '.av-tabs-nav button{flex:1 1 0;border:0;background:transparent;border-radius:999px;padding:11px 10px;font:inherit;font-weight:800;font-size:14px;color:#8A6555;cursor:pointer;line-height:1.2}',
    '.av-tabs-nav button[aria-selected="true"]{background:#8B5442;color:#fff}',
    '.av-tabs-panel{display:none;margin-top:12px}',
    '.av-tabs-panel.is-on{display:block}',
    '.av-box-grid{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}',
    '.av-box-card{display:flex;align-items:flex-start;gap:10px;background:#FFFBF8;border:1px solid #F0E2D9;border-radius:14px;padding:14px 12px}',
    '.av-box-card svg{flex:0 0 auto;width:26px;height:26px;stroke:#8B5442;fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}',
    '.av-box-card b{display:block;color:#8B5442;font-size:14px;line-height:1.25;margin-bottom:3px}',
    '.av-box-card span{display:block;color:#6B5148;font-size:12.5px;line-height:1.35}',
    '.av-spec-grid{display:flex;flex-wrap:wrap;gap:10px}',
    '.av-spec{flex:1 1 140px;display:flex;align-items:center;gap:10px;background:#FFFBF8;border:1px solid #F0E2D9;border-radius:14px;padding:12px 14px}',
    '.av-spec svg{flex:0 0 auto;width:24px;height:24px;stroke:#3C1E14;fill:none;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}',
    '.av-spec b{display:block;color:#3C1E14;font-size:15px;line-height:1.2}',
    '.av-spec span{display:block;color:#6B5148;font-size:12.5px}',
    '@media (max-width:480px){',
    '.av-tabs-nav button{font-size:13px;padding:10px 6px}',
    '.av-box-card{padding:12px 10px;gap:8px}',
    '.av-box-card svg{width:22px;height:22px}',
    '.av-box-card b{font-size:13px}',
    '.av-box-card span{font-size:12px}',
    '.av-spec{flex:1 1 100%}',
    '}'
  ].join('');

  function svg(name) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (ICON[name] || '') + '</svg>';
  }

  function esc(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function build(data) {
    var wrap = d.createElement('div');
    wrap.className = 'av-tabs';

    var boxCards = data.box.map(function (c) {
      return '<div class="av-box-card">' + svg(c[0]) + '<div><b>' + esc(c[1]) + '</b><span>' + esc(c[2]) + '</span></div></div>';
    }).join('');

    var specCards = data.specs.map(function (c) {
      return '<div class="av-spec">' + svg(c[0]) + '<div><b>' + esc(c[1]) + '</b><span>' + esc(c[2]) + '</span></div></div>';
    }).join('');

    wrap.innerHTML =
      '<div class="av-tabs-nav" role="tablist">' +
        '<button type="button" role="tab" aria-selected="true" aria-controls="av-tab-box">Dans la boîte</button>' +
        '<button type="button" role="tab" aria-selected="false" aria-controls="av-tab-spec">Caractéristiques</button>' +
      '</div>' +
      '<div class="av-tabs-panel is-on" id="av-tab-box" role="tabpanel"><div class="av-box-grid">' + boxCards + '</div></div>' +
      '<div class="av-tabs-panel" id="av-tab-spec" role="tabpanel"><div class="av-spec-grid">' + specCards + '</div></div>';

    var tabs = wrap.querySelectorAll('.av-tabs-nav button');
    var panels = wrap.querySelectorAll('.av-tabs-panel');
    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () {
        tabs.forEach(function (x, k) { x.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
        panels.forEach(function (p, k) { p.classList.toggle('is-on', k === i); });
      });
    });

    return wrap;
  }

  function init() {
    if (d.querySelector('.av-tabs')) return;
    var buybox = d.querySelector('.aevora-buybox');
    if (!buybox) return;

    var seg = location.pathname.split('/products/')[1];
    if (!seg) return;
    var handle = seg.split('/')[0].split('?')[0].split('#')[0];
    var data = DATA[handle];
    if (!data) return;

    var style = d.createElement('style');
    style.id = 'av-tabs-css';
    style.textContent = CSS;
    d.head.appendChild(style);

    var node = build(data);
    var anchor = buybox.querySelector('.aevora-accordions');
    if (anchor) { buybox.insertBefore(node, anchor); } else { buybox.appendChild(node); }
  }

  if (d.readyState === 'loading') { d.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
